import { BookingState } from '@/api/bookings';

export default {
	methods: {
		stateToText: function (state: any) {
			const that = this as any;
			if (state === BookingState.WAITING_FOR_CONFIRMATION)
				return that.$t('booking.waiting_for_validation');
			if (state === BookingState.CONFIRMED)
				return that.$t('booking.booked');
			if (state === BookingState.WAITING_FOR_CANCELLATION)
				return that.$t('booking.waiting_for_cancellation');
			if (state === BookingState.CANCELLED)
				return that.$t('booking.cancelled');
		}
	}
};
